export enum TrainerSessionTabEnum {
  STEPS = "Étapes",
  PARTICIPANTS = "Participants",
  DOCUMENTS = "Documents",
  EVALUATIONS = "Évaluations",
}
